import { useForm } from 'hooks/useForm'
import React, { FC } from 'react'
import { Button, Col, Form, Row } from 'react-bootstrap'
import { acceptInvite } from 'state/async_actions'
import { useAppContext } from 'state/context'
import { AcceptedInviteUser } from 'types'

export const AcceptInviteForm: FC<{ token: string }> = ({ token }) => {
  const [, dispatch] = useAppContext()

  const [formFields, handleInputChange, handleSubmit, validated] = useForm<
    AcceptedInviteUser
  >(acceptedUser => {
    acceptInvite(dispatch, token, acceptedUser)
  })

  const passwordsMatch = formFields.password === formFields.passwordConfirmation

  return (
    <>
      <Row>
        <Col>
          <h1>Welcome to the App!</h1>
          <p>
            You've been invited to join the App. Please provide some information
            below.
          </p>
        </Col>
      </Row>
      <Row>
        <Col>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Form.Group controlId="formFirstName">
              <Form.Label>First Name</Form.Label>
              <Form.Control
                onChange={handleInputChange}
                value={formFields.firstName || ''}
                name="firstName"
                type="text"
                placeholder="First Name"
              />
            </Form.Group>
            <Form.Group controlId="formLastName">
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                onChange={handleInputChange}
                value={formFields.lastName || ''}
                name="lastName"
                type="text"
                placeholder="Last Name"
              />
            </Form.Group>
            <Form.Group controlId="formPassword">
              <Form.Label>Password</Form.Label>
              <Form.Control
                onChange={handleInputChange}
                value={formFields.password || ''}
                name="password"
                type="password"
                placeholder="Enter Password"
                isValid={passwordsMatch}
              />
            </Form.Group>
            <Form.Group controlId="formPasswordConfirmation">
              <Form.Label>Password Confirmation</Form.Label>
              <Form.Control
                onChange={handleInputChange}
                value={formFields.passwordConfirmation || ''}
                name="passwordConfirmation"
                type="password"
                placeholder="Enter Password Again"
                isValid={passwordsMatch}
              />
            </Form.Group>
            <Button variant="primary" value="Accept Invite" type="submit">
              Save Profile
            </Button>
          </Form>
        </Col>
      </Row>
    </>
  )
}
